import { render, staticRenderFns } from "./AutoExtensionBadge.vue?vue&type=template&id=6a604c84&scoped=true&"
import script from "./AutoExtensionBadge.vue?vue&type=script&lang=js&"
export * from "./AutoExtensionBadge.vue?vue&type=script&lang=js&"
import style0 from "./AutoExtensionBadge.vue?vue&type=style&index=0&id=6a604c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a604c84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
